import * as Sentry from "@sentry/react";

const DEFAULT_SENTRY_DSN =
  "https://004d107fa1e814444959e186f11f7713@o4511097584418816.ingest.de.sentry.io/4511103560908880";

const configuredDsn = import.meta.env.VITE_SENTRY_DSN;
const dsn =
  configuredDsn && configuredDsn.trim().length > 0
    ? configuredDsn
    : DEFAULT_SENTRY_DSN;

if (dsn) {
  const tracesSampleRate = Number(
    import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? "1.0"
  );
  const replaysSessionSampleRate = Number(
    import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE ?? "0.1"
  );
  const replaysOnErrorSampleRate = Number(
    import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE ?? "1.0"
  );

  Sentry.init({
    dsn,
    environment:
      import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE ?? "dev",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate,
    replaysSessionSampleRate,
    replaysOnErrorSampleRate,
    sendDefaultPii: true,
  });
}

export { Sentry };
